import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Line } from '../../../context/context';
import type { FixedRoute } from '../../../types/fixedRoutes';

interface FixedRouteContextMenuProps {
    contextMenu: { x: number, y: number, line: Line, routeId: string, routeName: string } | null;
    onClose: () => void;
    onEditStyle: (routeId: string, routeName: string) => void;
    onOptimizeRoute: (routeId: string, routeName: string) => void;
    onEditGeometry?: (routeId: string) => void;
    onRecalculateFromStops?: (routeId: string) => void;
    isInEditMode?: boolean;
    isManuallyEdited?: boolean;
}

export default function FixedRouteContextMenu({
    contextMenu,
    onClose,
    onEditStyle,
    onOptimizeRoute,
    onEditGeometry,
    onRecalculateFromStops,
    isInEditMode = false,
    isManuallyEdited = false
}: FixedRouteContextMenuProps) {
    const { t } = useTranslation('map');
    if (!contextMenu) return null;

    return (
        <Menu
            open={Boolean(contextMenu)}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={
                contextMenu
                    ? { top: contextMenu.y, left: contextMenu.x }
                    : undefined
            }
            PaperProps={{
                sx: {
                    boxShadow: 3,
                    minWidth: 200,
                }
            }}
        >
            <MenuItem
                onClick={() => {
                    onEditStyle(contextMenu.routeId, contextMenu.routeName);
                    onClose();
                }}
            >
                {t('contextMenu.editStyle')}
            </MenuItem>
            {onEditGeometry && (
                <MenuItem
                    onClick={() => {
                        onEditGeometry(contextMenu.routeId);
                        onClose();
                    }}
                    disabled={isInEditMode}
                >
                    {isInEditMode ? t('contextMenu.editingGeometry') : t('contextMenu.editRouteGeometry')}
                </MenuItem>
            )}
            {onRecalculateFromStops && isManuallyEdited && (
                <MenuItem
                    onClick={() => {
                        onRecalculateFromStops(contextMenu.routeId);
                        onClose();
                    }}
                >
                    {t('contextMenu.recalculateFromStops')}
                </MenuItem>
            )}
            <MenuItem
                onClick={() => {
                    onOptimizeRoute(contextMenu.routeId, contextMenu.routeName);
                    onClose();
                }}
            >
                {t('contextMenu.optimiseRoute')}
            </MenuItem>
        </Menu>
    );
}

